import React from 'react'
import Simplert from 'react-simplert'
import Helmet from 'react-helmet'
import Input from '../../components/newInput/input'
// import validator from '../utilits/cpf_validator'
// import '../../style/pages/cadastro.scss'
import Loading from '../../components/loading/loading'
import axios from 'axios'
// import * as emailjs from 'emailjs-com'
import { Mutation } from "react-apollo"
import { UpdateUserDD, UpdateAddress } from '../../queries/player'
import { GraphQLClient } from 'graphql-request'
import { endpoint } from '../../queries/endpoint'
import CPF from 'gerador-validador-cpf'
import ErrorM from '../../components/ErrorMessange/errormenssage'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import dayjs from 'dayjs'
import Miniloading from '../../components/miniloading/miniloading'

import Button from "../../components/newButton/button";


export default class anuncios extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      value: '',
      submitOK: false,
      showAlert: false,
      loading: false,
      typeAlert: '',
      titleAlert: '',
      messageAlert: '',
      customCloseBtnText: 'Fechar',
      customCloseBtnClass: 'buttonnot', // colocar cor roxa
      onClose: null,
      spinnerdoc: false,
      docErr: null,
      dateok: false,
      dateErr: null,
      step: 1,
      zipErr: null,
    }

    this.form = {}
    const cache = JSON.parse(sessionStorage.getItem('OITO'))
    if (cache) {
      this.playerId = cache.user.id
      if (!cache.user.phoneverif) {
        window.location.href = '/verificartelefone'
      }
    } else {
      //alert que nao ta logado e redirect pra login
      this.setState({
        showAlert: true,
        typeAlert: 'error',
        titleAlert: 'Você não está logado',
        messageAlert: 'Entre ou cadastre-se. É gratuito!',
        onClose: () => window.location.href = '/login'
      })
    }

    this.getZipcode = async e => {
      this.setState({ submitOK: false, zipErr: null })
      this.form['zipcode'] = ''
      this.form['street'] = ''
      this.form['neighborhood'] = ''
      this.form['city'] = ''
      this.form['state'] = ''
      // const onlyNumbers = value => value.replace(/(^-{1})|(\d)|(\D)/g, "$1$2");
      const zipcode = e.target.value.replace("-", "");
      if (zipcode.match(/_/)) return false;
      try {
        this.setState({ getAddress: true });
        const address = await axios.get(`https://viacep.com.br/ws/${zipcode}/json/`, {})
        if (address.data && !address.data.erro) {
          this.form['zipcode'] = address.data.cep
          this.form['street'] = address.data.logradouro
          this.form['neighborhood'] = address.data.bairro
          this.form['city'] = address.data.localidade
          this.form['state'] = address.data.uf
          this.setState({ getAddress: false })
        } else {
          this.setState({
            getAddress: false,
            submitOK: false,
            zipErr: <ErrorM content='CEP inválido.' />
          })
        }
      } catch (e) {
        console.log("# zipcode error", e)
        if (zipcode.length > 8)
          this.setState({
            getAddress: false,
            submitOK: false,
            zipErr: <ErrorM content='CEP inválido.' />
          })
      }
    }; //_getZipcode

    this.blurDoc = (e) => {
      this.setState({
        showAlert: false,
        spinnerdoc: true,
        docErr: null,
      })

      this.form['doc'] = e.target.value

      if (this.form.doc && this.form.doc.length > 13 && !this.form.doc.match(/_/)) {
        this.setState({ spinnerdoc: true })
        if (CPF.validate(this.form.doc)) {
          const client = new GraphQLClient(endpoint)
          client.request(`
        {
          allUsers(filter: {
            document: "${this.form.doc.toString()}"
          }){
            id
            email
            name
            document
          }
        }
            `).then(
            res => {
              // console.log(res)
              if (res.allUsers.length > 0) {
                this.setState({
                  docErr: <ErrorM content='CPF já cadastrado.' />,
                  docok: false,
                  spinnerdoc: false
                })
              } else {
                this.setState({ docok: true, spinnerdoc: false, docErr: null })
                if (!this.state.dateok) {
                  this.setState({
                    dateok: false,
                    dateErr: <ErrorM content='Digite uma data válida. Não é necessário digitar as barras. Exemplo: 01/01/2000.' />
                  })
                }
              }
            }
          )
        } else {
          this.setState({ docErr: <ErrorM content='Seu CPF não é válido. Por favor, digite novamente sem pontos, barras ou traços. Ele deve conter 11 números.' /> })
        }
      } else if (this.form.doc.length > 11 && !this.form.doc.match(/_/)) {
        this.setState({
          docErr: <ErrorM content='Digite seu CPF.' />,
          docok: false,
          spinnerdoc: false
        })
      } else {
        this.setState({
          docErr: null,
          docok: false,
          spinnerdoc: false
        })
      }
    }

    this.blurDate = (e) => {
      this.form['birthday'] = e.target.value
      this.setState({ showAlert: false, dateok: false, dateErr: null })
      if (this.form.birthday) {
        // console.log(this.form.birthday)
        if (this.form.birthday.length >= 10) {
          const day = this.form.birthday.split('/')[0]
          const month = this.form.birthday.split('/')[1]
          const year = this.form.birthday.split('/')[2]
          const birth = year + '-' + month + '-' + day
          const date = dayjs(birth).toDate()
          // console.log(date)
          // console.log(dayjs(birth).isValid())
          // console.log(birth)
          if (dayjs(birth).isValid()) {
            const anos = dayjs().diff(date, 'month') / 12
            if (anos < 18) {
              this.setState({
                dateok: false,
                dateErr: <ErrorM content='Você precisa ser maior de 18 anos para se cadastrar.' />
              })
            } else if (anos >= 18 && anos < 120) {
              this.setState({ dateok: true, dateErr: null })
            } else {
              this.setState({
                dateok: false,
                dateErr: <ErrorM content='Digite uma data válida. Não é necessário digitar as barras. Exemplo: 01/01/2000.' />
              })
            }
          } else if (this.form.birthday !== "__/__/____" && !this.form.birthday.match(/_/)) {
            this.setState({
              dateok: false,
              dateErr: <ErrorM content='Digite uma data válida. Não é necessário digitar as barras. Exemplo: 01/01/2000.' />
            })
          }
        } else {
          this.setState({
            dateok: false,
            dateErr: <ErrorM content='Digite uma data válida. Não é necessário digitar as barras. Exemplo: 01/01/2000.' />
          })
        }
      }
    }

    this.blur = () => {
      this.setState({ showAlert: false, zipErr: null })

      if (this.form.number && this.form.street && this.form.city && this.form.state) {
        this.setState({ submitOK: true, zipErr: null })
      } else {
        if (!this.form.street) {
          this.setState({
            submitOK: false,
            zipErr: <ErrorM content='Digite a rua.' />
          })
        }
        if (!this.form.number) {
          this.setState({
            submitOK: false,
            zipErr: <ErrorM content='Digite o número do endereço.' />
          })
        }
        if (!this.form.city) {
          this.setState({
            submitOK: false,
            zipErr: <ErrorM content='Digite a cidade.' />
          })
        }
        if (!this.form.state) {
          this.setState({
            submitOK: false,
            zipErr: <ErrorM content='Digite a sigla do estado.' />
          })
        }
      }
    }

    this.sendRegister = (UpdateUserDD, e) => {
      e.preventDefault()
      this.setState({ showAlert: false, loading: true })
      if (!this.state.dateok) {
        this.setState({
          dateok: false,
          dateErr: <ErrorM content='Digite uma data válida. Não é necessário digitar as barras. Exemplo: 01/01/2000.' />
        })
      }

      if (!this.state.docok) {
        this.setState({
          dateok: false,
          dateErr: <ErrorM content='Seu CPF não é válido. Por favor, digite novamente sem pontos, barras ou traços. Ele deve conter 11 números.' />
        })
      }

      if (this.state.dateok && this.state.docok) {

        UpdateUserDD({
          variables: {
            document: this.form.doc.toString(),
            birthday: this.form.birthday.toString(),
          }
        }).then(
          res => {
            console.log(res)
            const cache = JSON.parse(sessionStorage.getItem('OITO'))

            const userAuth = {
              token: cache.token,
              user: res.data.updateUser
            }

            this.playerId = res.data.updateUser.id

            sessionStorage.setItem('OITO', JSON.stringify(userAuth))

            //enviar modal de confirmacao
            this.setState({
              loading: false,
              step: 2
            })
          }
        ).catch(err => console.log(err))
      }
    } //enviar cadastro

    this.updateAddress = (UpdateAddress, e) => {
      this.setState({ loading: true })
      e.preventDefault()

      UpdateAddress({
        variables: {
          zipcode: this.form.zipcode,
          street: this.form.street,
          number: this.form.number,
          complement: this.form.complement,
          neighborhood: this.form.neighborhood,
          city: this.form.city,
          state: this.form.state,
        }
      }).then(
        res => {
          // console.log(res.data)
          const cache = JSON.parse(sessionStorage.getItem('OITO'))

          // console.log(res)

          console.log("atualizando o storage")
          const userAuth = {
            token: cache.token,
            user: res.data.updateUser
          }

          sessionStorage.setItem('OITO', JSON.stringify(userAuth))

          console.log(JSON.parse(sessionStorage.getItem('OITO')))

          this.setState({
            showAlert: true,
            typeAlert: 'success',
            titleAlert: 'Cadastro atualizado com sucesso!',
            messageAlert: 'Feche este aviso para continuar',
            onClose: () => window.location.href = "/perfil",
            submitOK: false,
            loading: false
          })
        }
      )
    }

    const SetPerson = () => {
      return (
        <div className="col-xs-12">
          <div className="row center-xs middle-xs">
          <div className="col-xs-12 col-sm-8 col-md-6">
            <form>
                <Input icon={this.state.dateok ? 'fas fa-check' : 'fas fa-birthday-cake'} name="birthday" mask="99/99/9999" placeholder="Data de nascimento. DD/MM/AAAA" onChange={(e) => this.blurDate(e)} type="text" required />
                {this.state.dateErr}
                <OverlayTrigger
                  placement='right'
                  overlay={<Tooltip id="pqdate">A Oito exige que o usuário cadastrado seja maior de 18 anos de idade.</Tooltip>} >
                  <i className="fas fa-info"></i>
                </OverlayTrigger>
                
                <Input name="doc" placeholder="CPF. Ex.: xxx.xxx.xxx-xx" mask="999.999.999-99" type="text" onChange={(e) => this.blurDoc(e)} required />
                {this.state.docErr}
                <OverlayTrigger
                  placement='right'
                  overlay={<Tooltip id="pqdoc">A Oito requer um número de CPF válido para confirmar seus dados e fortalecer a credibilidade da nossa plataforma.</Tooltip>} >
                  <i className="fas fa-info"></i>
                </OverlayTrigger>

              <div style={{ justifyContent: 'center' }}>
                {this.state.spinnerdoc ? <Miniloading /> : null }
                <Mutation mutation={UpdateUserDD}>
                  {(UpdateUserDD, { loading, error }) => {
                    if (loading) return <Loading />
                    if (error) {
                      console.log(error)
                      return <ErrorM content='Aconteceu algo. Tente novamente' />
                    }
                    return <Button type="submit" onClick={(e) => this.sendRegister(UpdateUserDD, e)} disabled={(this.state.docok && this.state.dateok) ? false : true} name={'Próximo'} />
                  }}
                </Mutation>
              </div>
            </form>
            </div>
          </div>
        </div>
      )
    }

    const SetAddress = () => {
      return (
        <div className="address-form col-xs-12" style={{ maxWidth: "800px"}}>
          <div className="row center-xs middle-xs">
            <div className="col-xs-12">
              <h3>Endereço</h3>
            </div>
            
          <div className="col-xs-12">
            {this.state.zipErr}
          </div>
          <div className="col-xs-12 col-sm-6 col-md-4">
            <Input mask="99999-999" onChange={(e) => this.getZipcode(e)} name="zipcode" placeholder="CEP. Ex.: 00000-000" type="text" />
            <p style={{ textAlign: "right", fontSize: "0.8rem" }}><a href="http://www.buscacep.correios.com.br/sistemas/buscacep/buscaCepEndereco.cfm" target="_blank" rel="noopener noreferrer">Não sei meu CEP</a></p>
            <OverlayTrigger
              placement='right'
              overlay={<Tooltip id="pqaddress">A Oito exige que você cadastre um endereço válido para manter a integridade da nossa plataforma.</Tooltip>} >
              <i className="fas fa-info"></i>
            </OverlayTrigger>
          </div>
          {this.state.getAddress ? <Miniloading /> : null}
          {this.form.state ? <div className={'form-complete col-xs-12 row'} >
            <div className="street col-xs-12">
              <Input onInput={(e) => this.form.street = e.target.value} onChange={this.blur} name="street" value={this.form.street} label="Endereço" placeholder="Rua, Avenida ou Logradouro." type="text" />
            </div>

            <div className="num col-xs-12 col-sm-6">
              <Input onInput={(e) => this.form.number = e.target.value} onChange={this.blur} name="number" placeholder="Número. Ex.: 00" type="text" required={true} />
            </div>

            <div className="complement col-xs-12 col-sm-6">
              <Input onInput={(e) => this.form.complement = e.target.value} onChange={this.blur} name="complement" placeholder="Complemento. Ex.: Apto 1101" type="text" />
            </div>

            <div className="neighborhood col-xs-12">
              <Input onInput={(e) => this.form.neighborhood = e.target.value} onChange={this.blur} name="neighborhood" value={this.form.neighborhood} placeholder="Bairro" type="text" />
            </div>

            <div className="city col-xs-12">
              <Input onChange={this.blur} name="city" value={this.form.city} placeholder="Cidade" type="text" />
            </div>

            <div className="state col-xs-12">
              <Input onChange={this.blur} name="state" value={this.form.state} placeholder="Estado" type="text" />
            </div>

            <div className="col-xs-12" style={{ justifyContent: 'center' }}>
              <Mutation mutation={UpdateAddress}>
                {(UpdateAddress, { loading, error }) => {
                  if (loading) return <Loading />
                  if (error) console.log(error.message)
                  return <Button type="submit" onClick={(e) => this.updateAddress(UpdateAddress, e)} disabled={!this.state.submitOK ? true : false} name={'Concluir'}></Button>
                }}
              </Mutation>
            </div>
          </div> : null}
          </div>
          
        </div>
      )
    }

    this.showSteps = () => {
      switch (this.state.step) {
        case 2: //endereço
          return <SetAddress />
        case 1:
        default: //dados
          return <SetPerson />
      }
    }

  }

  componentDidMount() {
    const cache = JSON.parse(sessionStorage.getItem('OITO'))
    // console.log(cache)
    if (!cache.user.document || !cache.user.birthday) {
      this.setState({ step: 1 })
    } else if (cache.user.document && cache.user.birthday && !cache.user.address.city) {
      this.setState({ step: 2 })
    } else if (cache.user.document && cache.user.birthday && cache.user.address.city){
      window.location.href = '/perfil'
    }
  }

  render() {

    return (
      <div className="col-xs-12" style={{ marginTop: '25px' }}>
        <Helmet>
          <title>Oito - Complete seus dados</title>
          <meta name="description" content="Faça seu cadastro em Oito.app e encontre profissionais qualificados e confiáveis para solucionar seus problemas, ou divulgue seus serviços e encontre oportunidades imperdíveis." />
          <meta name="keywords" content="Cadastro, Oportunidades, Serviços" />
          <meta name="robots" content="index, follow" />
          <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
          <meta name="language" content="Portuguese" />
          <meta name="revisit-after" content="1 days" />
        </Helmet>
        <Simplert
          showSimplert={this.state.showAlert}
          type={this.state.typeAlert}
          title={this.state.titleAlert}
          message={this.state.messageAlert}
          customCloseBtnText={this.state.customCloseBtnText}
          customCloseBtnClass={this.state.customCloseBtnClass}
          onClose={this.state.onClose}
        />
        <div className="row">
          <div className="col-xs-12">
            <h1>Complete seus dados</h1>
          </div>
          <div className="col-xs-12">
            <form className="register-box row center-xs" id="myform" style={{ marginBottom: "30px" }}>
              {this.showSteps(this.state.step)}
            </form>
          </div>
        </div>
      </div>
    )
  }
}
